import styled from 'styled-components';

export default styled.div`
  position: absolute;
  display: block;
  z-index: 9999;
  background: rgba(111, 88, 255, 0.8);
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.25rem;
  padding: 0.5rem 0.25rem;
  text-align: center;
  border-radius: 0.3rem;
  width: 7rem;
  transform: translate(50%,0);
  right: 50%;
  z-index: 1;

  &:hover {
    background: rgba(111, 88, 255, 1);
    text-decoration: underline;
  }
`;
